import React from 'react';
import PropTypes from 'prop-types';
import FavoriteOutlined from '@tamagoshi/core/cjs/iconsSystem/HeartBorder';

const ListB2B = ({ size }) => <FavoriteOutlined width={size} height={size} />;

ListB2B.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ListB2B.defaultProps = {
  size: 24,
};

export default ListB2B;
